export default "<ion-content>\n  <h1>\n    Woops! Page Not Found!\n  </h1>\n  <a routerLink=\"/main/tabs/home\"> Go back to HomePage</a>\n</ion-content>\n";